import { BillingOffersObject } from './billing-offers/billing-offers-object.model';

export class OrderDetailsBillingObject {

    constructor(private billingDate: string, private clickedId: number, private offerList: Array<BillingOffersObject>) {
    }

    static create() {
        return new OrderDetailsBillingObject('ninguna', 0, new Array<BillingOffersObject>());
    }

    public getBillingDate(): string {
        return this.billingDate;
    }

    public setBillingDate(billingDate: string) {
        this.billingDate = billingDate;
    }

    public getClickedId(): number {
        return this.clickedId;
    }

    public setClickedId(clickedId: number) {
        this.clickedId = clickedId;
    }

    public getOfferList(): Array<BillingOffersObject> {
        return this.offerList;
    }

    public setOfferList(offerList: Array<BillingOffersObject>) {
        this.offerList = offerList;
    }
}
